exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".limit[data-v-fdf97870] {\n  max-height: 50vh;\n  overflow-y: scroll;\n}\n.accountsettings-bar[data-v-fdf97870] {\n  margin: 0 auto 0 0;\n  color: #c3c3c3;\n  background: #c3c3c3;\n  height: 1px;\n}", ""]);

// exports
